import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import {
  isMobile
} from "react-device-detect";

export default class Carddetailpopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open: false,
      card: null,
      kinds: null,
      monthFeeValue: 0,
      monthValue: 24,
      discountValue: 0,
      isPre: true
    };

    this._monthBox = null;
    this._monthFee = null;

    this._monthFeeDefault = 0;
  }
  Open(card, isPre)
  {
    let parsedKinds = JSON.parse(card.kinds);
    for(let i=0;i<parsedKinds.length;i++)
    {
      if(i==0)
      {
          this._monthFeeDefault = parsedKinds[i].discount;
          parsedKinds[i].default = true;
      } else {
          parsedKinds[i].default = false;
      }
    }
    console.log(card);
    this.setState({
      open: true,
      card: card,
      kinds: parsedKinds,
      isPre: isPre
    },this.recalc);
  }
  Close()
  {
    this.setState({
      open: false
    });
  }
  feeChange(event)
  {
    const self = this;
    if( event )
    {
      self.setState({
        monthFeeValue: event.target.value
      },self.recalc);
    }
  }
  monthChange(event)
  {
    const self = this;
    self.setState({
      monthValue: event.target.value
    },self.recalc);
  }
  recalc()
  {
    const self = this;
    let result = 0;
    if( this._monthFeeObj && this._monthObj ){
        result = this._monthFeeObj.value * this._monthObj.value;
    } else {
        result = this._monthFeeObj.value;
    }

    self.setState({
      discountValue: result
    })
  }
  Apply(card)
  {
      if( this._monthObj )
      {
        this.props.onCardSelected(card,this._monthFeeObj.value,this._monthObj.value);
      } else {
        this.props.onCardSelected(card,this._monthFeeObj.value);
      }

  }
  render()
  {
    const self = this;
    //<img src={"http://mbadmin.nebi.co.kr/uploads/card/"+self.props.select_model_idx+"_"+color.hex+".jpg"} />
    let imgPath = 'https://api.tfamily.co.kr/uploads/card/';
    if( self.state.card ) {
        imgPath += self.state.card.idx + '.jpg';
    }
    return(

      <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
          <div className="modal-dialog modal-lg mb0 ">
            <div className={(isMobile) ? 'popupPadding3' : 'popupPadding pr45'}>
                <div className="md-popup-header"> &nbsp;{(self.state.card) ? self.state.card.name : ''}</div>
                <div className="md-popup-contents carddetailpopup">
                  <div className="row">
                    <div className="col-xs-12 col-md-5">
                        <img className="img-responsive" src={imgPath} />
                    </div>
                    <div className="col-xs-12 col-md-7">
                      <table className="cardDetailTable">
                        <tbody>
                        { (self.state.card) ? (self.state.card.part == "A") ?
                        <tr>
                          <td><b>카드구분</b></td>
                          <td>&nbsp;&nbsp;라이트할부카드</td>
                        </tr>
                        :
                        <tr>
                          <td><b>카드구분</b></td>
                          <td>&nbsp;&nbsp;세이브할부카드</td>
                        </tr>
                        : '' }
                        { (self.state.card) ? (self.state.card.pay == 2) ?
                        <tr>
                          <td><b>결제구분</b></td>
                          <td>&nbsp;&nbsp;자동이체 필수</td>
                        </tr>
                        :
                        <tr>
                          <td><b>결제구분</b></td>
                          <td>&nbsp;&nbsp;자동이체 무관</td>
                        </tr>
                        : '' }
                        { (self.state.card) ?
                        <tr>
                          <td><b>연회비</b></td>
                          <td>&nbsp;&nbsp;{self.state.card.dues}</td>
                        </tr>
                        : '' }
                        { (self.state.card) ?
                        <tr>
                          <td><b>발급전화</b></td>
                          <td>&nbsp;&nbsp;{self.state.card.tel}</td>
                        </tr>
                        : '' }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row pt30">
                    <div className="col-xs-12 col-md-2">
                     <b>카드 혜택</b>
                    </div>
                    <div className="col-xs-12 col-md-10">
                      <textarea className="form-control height300" defaultValue={(self.state.card) ? self.state.card.description : ''} readOnly="readOnly"></textarea>
                    </div>
                  </div>
                  <div className="row pt20">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-xs-4"><b>월 사용액</b></div>
                        <div className="col-xs-8">
                          <select onChange={self.feeChange.bind(this)} value={self.state.monthFeeValue} ref={(ref)=>{self._monthFeeObj=ref}} className="form-control" >
                          {
                            ( self.state.kinds ) ?
                              self.state.kinds.map((kind,index)=>{
                                let defaultValue = '';
                                if(kind.default) {
                                  defaultValue = 'selected';
                                }
                                return (<option key={index} value={kind.discount}>{kind.description}</option>);
                              })
                             : ''
                          }
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">

                        {(self.state.isPre) ?
                            <div className="row">
                            <div className="col-xs-4"><b>할부기간</b></div>
                            <div className="col-xs-8">
                              <select onChange={self.monthChange.bind(this)} value={self.state.monthValue} ref={(ref)=>{self._monthObj=ref}}   className="form-control">
                                <option value="18">18개월</option>
                                <option value="24">24개월</option>
                                <option value="36">36개월</option>
                              </select>
                            </div>
                            </div> :
                            <div className="row">
                            </div>
                        }
                    </div>
                  </div>
                  <div className="pt40">

                    <div className="row text-center">
                        {(self.state.isPre) ?  <h4><b>할인 총액 : {number_input_format(self.state.discountValue)} 원</b></h4> : <h4><b>월 할인 총액 : {number_input_format(self.state.discountValue)} 원</b></h4> }
                    </div>

                  </div>
                  <div className="pt40">
                    <div className="row text-center">
                      <a href="#applyCard" onClick={()=>{self.Apply(self.state.card)}} className="btn btn-bar btn-lg btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                      <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-lg btn-select2">취소</a>
                    </div>
                  </div>
                </div>
            </div>
          </div>
      </Modal>
    );
  }
}
